import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'fleetoperate-environment-ribbon',
    templateUrl: './environment-ribbon.component.html',
    styleUrls: ['./environment-ribbon.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class EnvironmentRibbonComponent implements OnInit {
  @Input() position: string;
  @Input() colour: string;
  @Input() text: string;
  @Input() hoverText: string;
  constructor() {}

  ngOnInit() {}
}
